import { computed as o, createBlock as n, createCommentVNode as l, openBlock as s, resolveDynamicComponent as i } from "vue";
import { illustrations as u } from "@dialpad/dialtone-icons/vue3";
import { ILLUSTRATION_NAMES as m } from "./illustration-constants.js";
const f = /* @__PURE__ */ Object.assign({
  name: "DtIllustration"
}, {
  __name: "illustration",
  props: {
    /**
       * The illustration name in kebab-case
       */
    name: {
      type: String,
      required: !0,
      validator: (t) => m.includes(t)
    }
  },
  setup(t) {
    const e = t, a = o(() => u[`./src/illustrations/${e.name}.vue`]);
    return (r, c) => a.value ? (s(), n(i(a.value), {
      key: 0,
      "data-qa": r.$attrs["data-qa"] ?? "dt-illustration"
    }, null, 8, ["data-qa"])) : l("", !0);
  }
});
export {
  f as default
};
//# sourceMappingURL=illustration.js.map
